import { logger, type Debug } from "@otto-ec/global-resources/debug";

/**
 */
export const createLogger = <TNamespace extends string, TScope extends string>(
    namespace: TNamespace,
    scope: TScope
): Debug<`benefit.${TNamespace}.${TScope}`> => logger(`benefit.${namespace}.${scope}`);